// Design-only screens, second pass (D-044): the visitor report, seen in the Zalient admin on 2026-10-21
// (Digital products became a live Settings page on 2026-10-22).
// Our own layout and tokens; no data is read or written.
import type { ComponentType } from "react";
import { t } from "@ady/i18n";
import { Icon } from "@ady/ui";
import type { NavItem } from "../shell/nav";
import { DesignPage, SectionTitle } from "./kit";

import { RootHead } from "../ai-mascot/RootHead";
type Screen = ComponentType<{ item: NavItem }>;

const Traffic: Screen = ({ item }) => (
  <DesignPage item={item} lead={t("designs.traffic.lead")}>
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {(["visits", "visitors", "bounce", "session"] as const).map((k) => (
        <div key={k} className="flex flex-col gap-1 rounded-xs border border-card bg-surface p-4">
          <span className="text-xs text-fg-secondary">{t(`designs.traffic.stats.${k}`)}</span>
          <span className="text-title-sm font-bold text-fg-tertiary">{t("designs.notLive")}</span>
        </div>
      ))}
    </div>
    <div className="grid gap-3 lg:grid-cols-2">
      <section className="flex flex-col gap-3 rounded-xs border border-card bg-surface p-4">
        <SectionTitle>{t("designs.traffic.funnel")}</SectionTitle>
        <ol className="flex flex-col gap-2">
          {(["visited", "viewed", "checkout", "ordered"] as const).map((k, i) => (
            <li key={k} className="flex flex-col gap-1">
              <span className="text-xs text-fg-secondary">
                {t(`designs.traffic.funnelSteps.${k}`)}
              </span>
              <span
                className="h-3 rounded-full bg-sunken"
                style={{ width: `${100 - i * 22}%` }}
                aria-hidden="true"
              />
            </li>
          ))}
        </ol>
        <p className="text-xs text-fg-tertiary">{t("designs.traffic.emptyBody")}</p>
      </section>
      <section className="flex flex-col gap-3 rounded-xs border border-card bg-surface p-4">
        <SectionTitle>{t("designs.traffic.devices")}</SectionTitle>
        <ul className="flex flex-col gap-2">
          {(
            [
              ["monitor", "desktop"],
              ["phone", "mobile"],
              ["tablet", "tablet"],
            ] as const
          ).map(([icon, k]) => (
            <li key={k} className="flex items-center gap-2 text-sm">
              <Icon name={icon} className="text-fg-tertiary" />
              <span className="flex-1">{t(`designs.traffic.deviceNames.${k}`)}</span>
              <span className="h-2 w-24 rounded-full bg-sunken" aria-hidden="true" />
            </li>
          ))}
        </ul>
        <SectionTitle>{t("designs.traffic.sources")}</SectionTitle>
        <p className="text-xs text-fg-tertiary">{t("designs.traffic.emptyBody")}</p>
      </section>
    </div>
    <section className="flex items-start gap-3 rounded-xs border border-card bg-surface p-4">
      <span className="ady-bg-brand-tint flex size-10 flex-none items-center justify-center rounded-xs">
        <RootHead size={28} />
      </span>
      <div className="flex flex-col gap-0.5">
        <SectionTitle>{t("designs.traffic.noticed")}</SectionTitle>
        <p className="text-xs text-fg-secondary">{t("designs.traffic.noticedBody")}</p>
      </div>
    </section>
  </DesignPage>
);

export const STUDIO_SCREENS: Record<string, Screen> = {
  traffic: Traffic,
};
